import React from 'react'
import { RadioGroup } from '@headlessui/react'
import {TransProps} from '@lingui/react'
import {getColor} from 'components/utils'


// Type
export type typeSelectButtonDataListItem = {
    id: string,
    title?: React.ReactElement<TransProps> | string,
    icon?: React.ReactElement<JSX.Element>,
}

export type typeSelectPanel = {
    variant?: string
    label?: React.ReactElement<TransProps>
    dataList: typeSelectButtonDataListItem[]
    itemClassName?: string
    iconClassName?: string

    checkedId: string | null
    setCheckedId: React.Dispatch<React.SetStateAction<string | null>>
}

// @ts-ignore
function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}


// Component
export const SelectButtons:React.FC<typeSelectPanel> = ({variant, label, dataList, itemClassName, iconClassName, checkedId, setCheckedId}) => {

    const color = getColor(variant)

    return (

        <RadioGroup value={checkedId} onChange={setCheckedId}>

            {label
                ? <RadioGroup.Label className="block mb-1 text-sm font-medium text-gray-700 text-left">{label}</RadioGroup.Label>
                : null
            }

            <div className="flex border border-gray-300 rounded-md shadow-sm divide-x overflow-hidden">
                {dataList.map((item) => (
                    <RadioGroup.Option
                        key={item.id}
                        value={item.id}
                        className={({checked}) =>
                            classNames(
                                checked ? `bg-${color}-500 text-white` : 'text-gray-900',
                                itemClassName ? itemClassName : '',
                                'relative bg-white flex cursor-pointer',
                            )
                        }
                    >
                        {({ checked}) => (
                            <div className="flex-1 flex justify-center items-center py-1 px-2">
                                <div className="flex flex-col justify-center items-center">
                                    {item.icon
                                        ? <div className={iconClassName ? iconClassName : undefined}>
                                            {item.icon}
                                        </div>
                                        : null
                                    }
                                    <RadioGroup.Label as="span" className="block text-sm font-medium">
                                        {item.title}
                                    </RadioGroup.Label>
                                </div>
                            </div>
                        )}
                    </RadioGroup.Option>
                ))}
            </div>
        </RadioGroup>
    )
}
